import { render, staticRenderFns } from "./Fieldset.vue?vue&type=template&id=e458611a&scoped=true&"
import script from "./Fieldset.vue?vue&type=script&lang=ts&"
export * from "./Fieldset.vue?vue&type=script&lang=ts&"
import style0 from "./Fieldset.vue?vue&type=style&index=0&id=e458611a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458611a",
  null
  
)

export default component.exports